<template>
  <div class='dataContainerAdd'>       
    <div class="panel panel-primary" >
        <div class="panel-heading">Informacion general</div>
        <div class="panel-body">
             <div class="input-group form-group">
                <span class="input-group-addon input-group-addon-general">Titulo</span>
                <span class='input-data-width' ><input type="text" class="form-control"  v-model='newCarObj.title' ></span>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCurrencyDetails'>
                <span class="input-group-addon input-group-addon-general">Moneda</span>
                <select class="form-control" v-model='newCarObj.currency_id'  >                                                          
                    <option v-for="currencyDetail in dropDownDetails.currencyDetails" v-bind:value='currencyDetail.id'  > {{currencyDetail.name}} </option>
                </select>
            </div>
            <div class="input-group form-group ">
                <span class="input-group-addon input-group-addon-general">Precio</span>
                <input type="text" class="form-control"  v-model='newCarObj.price' v-on:keyup='allowDecimalOnly' >
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon input-group-addon-general">Precio de oferta</span>
                <input type="text" class="form-control"  v-model='newCarObj.offerprice' v-on:keyup='allowDecimalOnly' >
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon input-group-addon-general">Descripcion</span>
                <textarea class="form-control"  v-model='newCarObj.description' rows="10"  ></textarea>
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Activo</span>                               
                <select class="form-control" v-model='newCarObj.active' >                                                          
                    <option value="0"> No </option>
                    <option value="1"> Si </option>
                </select>
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Prioridad</span>
                <select class="form-control" v-model='newCarObj.priority' >                                                          
                    <option v-for='n in 99'> {{ n }} </option>
                </select>
            </div> 
        </div>
    </div>
    <div class="panel panel-primary">
        <div class="panel-heading">Fotos</div>
        <div class="panel-body mobileText">
             <ImageUpload v-bind:carForSaleID="newCarObj.id" ></ImageUpload>
        </div>
    </div>
    <div class="panel panel-primary">
        <div class="panel-heading">Informacion especifica</div>
        <div class="panel-body">            
            <div class="input-group form-group">
                <span class="input-group-addon">Año</span>
                <select class="form-control" v-model='newCarObj.model_year' >                                                          
                    <option v-for='n in ((new Date().getFullYear()) - 1980)' > {{ n + 1980 }} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarBrandDetails'>
                <span class="input-group-addon">Marca</span>
                <select class="form-control" v-model='newCarObj.car_brand_id' v-on:change="changeCarBrand(dropDownDetails.carBrandDetails)" >                                                                             
                    <option v-for="carBrandDetail in dropDownDetails.carBrandDetails" v-bind:value='carBrandDetail.id' > {{carBrandDetail.name}} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarModelDetails' v-show='carModelDetailsFiltered.length > 1'>
                <span class="input-group-addon">Modelo</span>
                <select class="form-control" v-model='newCarObj.car_model_id' >                                                          
                    <option v-for="carModelDetail in carModelDetailsFiltered" v-bind:value='carModelDetail.id'  > {{carModelDetail.name}} </option>
                </select>
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Millage</span>
                <input type="text" class="form-control"  v-model='newCarObj.odometer' v-on:keyup='allowIntOnly' >
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">CC</span>
                <input type="text" class="form-control"  v-model='newCarObj.enginecc' v-on:keyup='allowIntOnly' >
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Cilindros</span>
                <select class="form-control" v-model='newCarObj.enginecylinders' >                                                          
                    <option v-for='n in 12'> {{ n }} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarExteriorColors'>
                <span class="input-group-addon">Color exterior</span>
                <select class="form-control" v-model='newCarObj.exteriorcolor_id'  >                                                          
                    <option v-for="carExteriorColor in dropDownDetails.carExteriorColors" v-bind:value='carExteriorColor.id' > {{carExteriorColor.name}} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarInteriorColors'>
                <span class="input-group-addon">Color interior</span>
                <select class="form-control" v-model='newCarObj.interiorcolor_id'  >                                                          
                    <option v-for="carInteriorColor in dropDownDetails.carInteriorColors" v-bind:value='carInteriorColor.id' > {{carInteriorColor.name}} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarFuelTypes'>
                <span class="input-group-addon">Combustible</span>
                <select class="form-control" v-model='newCarObj.fueltype_id'  >                                                          
                    <option v-for="carFuelType in dropDownDetails.carFuelTypes" v-bind:value='carFuelType.id' > {{carFuelType.name}} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarTransmissions'>
                <span class="input-group-addon">Transmission</span>
                <select class="form-control" v-model='newCarObj.transmissiontype_id'  >                                                          
                    <option v-for="carTransmission in dropDownDetails.carTransmissions" v-bind:value='carTransmission.id' > {{carTransmission.name}} </option>
                </select>
            </div>
             <div class="input-group form-group" v-if='dropDownDetails.showCarTypeDetails'>
                <span class="input-group-addon">Tipo</span>
                <select class="form-control" v-model='newCarObj.typevehicle_id'  >                                                          
                    <option v-for="carTypeDetail in dropDownDetails.carTypeDetails" v-bind:value='carTypeDetail.id' > {{carTypeDetail.name}} </option>
                </select>
            </div>
            <div class="input-group form-group" v-if='dropDownDetails.showCarTractionDetails'>
                <span class="input-group-addon">Traccion</span>
                <select class="form-control" v-model='newCarObj.tractiontype_id'  >                                                          
                    <option v-for="carTractionDetail in dropDownDetails.carTractionDetails" v-bind:value='carTractionDetail.id' > {{carTractionDetail.name}} </option>
                </select>
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Puertas</span>
                <select class="form-control" v-model='newCarObj.doors' >                                                          
                    <option v-for='n in 8'> {{ n }} </option>
                </select>
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Pasajeros</span>
                <select class="form-control" v-model='newCarObj.passengers' >                                                          
                    <option v-for='n in 15'> {{ n }} </option>
                </select>
            </div>           
        </div>
    </div>        
    <InfoMessage></InfoMessage>
    <button class="btn btn-primary btn-block"  @click='validateFields' >Guardar</button>
    <br><br><br>
  </div>
</template>

<script>
import { eventBus } from '../main';
import { CommonMixin } from './mixin/CommonMixin';
export default {  
  mixins : [CommonMixin],  
  data: function () {     
    return {
        newCarObj: {   
            id: 0,         
            title: '',
            description: '',
            car_brand_id: 0,
            car_model_id: 0,
            model_year: 2016,
            currency_id: 1,
            price: 0.0,
            offerprice: 0.0,
            odometer: 80000,
            enginecc: 1300,
            enginecylinders: 3,
            exteriorcolor_id: 0,
            interiorcolor_id: 0,
            fueltype_id: 1,
            transmissiontype_id: 1,
            typevehicle_id: 2,
            tractiontype_id: 1,
            doors: 4,
            passengers: 5,
            photos_name: ' ',
            priority: 50,
            active: 1,
            deleted: 0,
            imageLists: [],
        },
        itemDetails: [],
        gotData: false,  
        gotCarData: false,  
        carModelDetailsFiltered: [],        
        imagePriority: 99
    }
  },
  created: function () {            
    eventBus.$on('imageUpload', response => {
        this.newCarObj.imageLists = response.map( (obj) => {
            return obj.name;
        });
    });     

    eventBus.$on('imageSelected', response => {
        this.imagePriority = response;        
    });     
  },
  mounted: function () {        
      if(this.itemDetail) {         
            this.newCarObj = this.itemDetail;                
            this.changeCarBrand();           
            this.gotCarData = true;         
       }    
  },
  methods: {    
    changeCarBrand: function(){        
        this.carModelDetailsFiltered = this.dropDownDetails.carModelDetails.filter((carBrandDetails) => {            
            return this.newCarObj.car_brand_id == carBrandDetails.carbrand_id;
        });
        
        this.carModelDetailsFiltered.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1})
    },
    validateFields: function(){
        
        eventBus.$emit('hide');        

        if(this.newCarObj.id == 0){
            if(!this.newCarObj.imageLists || this.newCarObj.imageLists.length == 0){                    
                eventBus.$emit('genericMessage', false, 'Favor Agregar fotos');
                return;
            }            
        }

        if(this.newCarObj.title == ''){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Titulo"');
            return;
        }

        if(this.newCarObj.price == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Precio"');
            return;
        }

        if(this.newCarObj.offerprice == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Oferta de precio"');
            return;
        }

        if(this.newCarObj.description == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Descripcion"');
            return;
        }

        if(this.newCarObj.car_brand_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Marca"');
            return;
        }

        if(this.carModelDetailsFiltered.length == 0)
            eventBus.$emit('genericMessage', false, 'Favor llenar "Modelo"');

        if(this.newCarObj.car_model_id === undefined || this.newCarObj.car_model_id == 0){                    
            eventBus.$emit('genericMessage', false, 'Favor llenar "Modelo"');
            return;
        }        

        if(this.newCarObj.odometer == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Millage"');
            return;
        }

        if(this.newCarObj.enginecc == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "CC"');
            return;
        }

        if(this.newCarObj.enginecylinders == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Cilindros"');
            return;
        }

        if(this.newCarObj.exteriorcolor_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Color exterior"');
            return;
        }

        if(this.newCarObj.interiorcolor_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Color interior"');
            return;
        }

        if(this.newCarObj.fueltype_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Combustible"');
            return;
        }

        if(this.newCarObj.transmissiontype_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Transmission"');
            return;
        }

        if(this.newCarObj.typevehicle_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Tipo"');
            return;
        }

        if(this.newCarObj.tractiontype_id == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Traccion"');
            return;
        }

        if(this.newCarObj.doors == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Puertas"');
            return;
        }

        if(this.newCarObj.passengers == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Pasajeros"');
            return;
        }

        if(!this.newCarObj)
            return;
                
        var insertedId = this.newCarObj.id;

        if(this.newCarObj.id == 0) {
            this.$http.post('api/carforsale/', this.newCarObj).then(response => {                  
                insertedId = response.body.insertedId;                
                this.saveImages(insertedId);
            }, response => {                            
                eventBus.$emit('errorMsg',response);          
            });
        }
        else{            
            this.$http.put('api/carforsale/' + this.newCarObj.id, this.newCarObj).then(response => {                        
                eventBus.$emit('resultMessage',response);                           
                this.saveImages(insertedId);
            }, response => {            
                eventBus.$emit('errorMsg',response);          
            });            
        }                
    },
    saveImages: function(insertedId) {

        if(this.newCarObj.imageLists){
            this.newCarObj.imageLists.forEach((obj) => {                

                var priority = 99;                    
                if(this.imagePriority == obj)
                    priority = 1;                                                            

                var imageInfo = {name:obj, car_for_sale_id:insertedId, active:1, deleted:0, priority:priority };

                this.$http.post('api/imageupload/', imageInfo).then(responseImages => {                                                                        
                    
                    if(this.newCarObj.id == 0)
                        this.$router.push('/view/carForsaleview/' + insertedId);        

                }, response => {                                  
                    eventBus.$emit('errorMsg',response);          
                });
            });
        }        
    }   
  },
  filters: {
     
  },
  computed: {
    
  },  
  watch: {        
    
  },
  props:['itemDetail', 'dropDownDetails']
}
</script>

<style scoped>
    .dataContainerAdd{       
       padding-left: 15px;       
       width:700px;
    }

    .input-group-addon { 
        width: 150px; 
    }

    .input-group { 
        width: 100%; 
    }

    @media screen and (max-width: 981px) {  

        .dataContainerAdd{          
          width:100%;
        }

       .panel-heading{
            font-size: 3em;            
        }
     
       .Title {    
            font-size:3em;
       }
        input {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 2em;            
        }

        select {        
            position:relative;
            width:100%;
            height:75px;
            font-size: 2em;            
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 2.8em;                        
        }

        button {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 3em;
        }

        .mobileText {
            font-size: 3em;            
        }

        textarea {
             font-size: 2.4em; 
        }
   }
 
</style>



// WEBPACK FOOTER //
// CarForSaleAdd.vue?6bcca3a9